const isEliteUser = (userId) => {
  let eliteUsers = [
    "6655d9b40777525410c88982", // Aksha
    "651bd4c8ad7773279c5ae380", // Vanshita
    "6655da0d21d3e92d1b400e27", // Amit
    "694a668f7ea5dd48e26e5568", // Khushi
    "6746d54f4d93e350eadae03f", // Darshan
    "67b6eb62244cb99b99e46a9b", // Vishal
  ];
  return eliteUsers.includes(userId);
};

export default isEliteUser;
